<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <!--          <span class="glyphicon glyphicon-earphone"></span>888-888-888-->
          <!--          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com-->
          <!--          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务-->
        </div>
        <div class="shejiao pull-right">
          <ul class="language">
            <li :class="{'active-lang':lang === 'tc'}" @click="selectLang('tc')">繁</li>
            <li>|</li>
            <li :class="{'active-lang':lang === 'sc'}" @click="selectLang('sc')">简</li>
            <li>|</li>
            <li :class="{'active-lang':lang === 'en'}" @click="selectLang('en')">ENG</li>
            <li>|</li>
            <li>
              <a target="_blank" href="https://www.facebook.com/checkpoint/1501092823525282">
                <img src="@/assets/images/fb-mobile.png" alt="">
              </a>
            </li>
            <!--            <li>|</li>-->
            <!--            <li class="shop">-->
            <!--              <a target="_blank" href="https://starofcanton.store/?lang=zh-Hans&currency=HKD">-->
            <!--                <img src="@/assets/images/e-shop.png" alt="">-->
            <!--              </a>-->
            <!--            </li>-->
          </ul>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs animate__animated animate__fadeInDown animate__faster">
      <!-- 导航logo -->
      <div class="header-nav-logo coffee-logo">
        <a href="https://kafelaku.com/" target="_blank">
          <img src="@/assets/images/coffee-logo.png">
        </a>
      </div>
      <div class="header-nav-logo">
        <a href="/libaoge/#" target="_blank">
          <img src="@/assets/images/logo.png">
        </a>
      </div>
      <div class="header-nav-logo libaohouse">
        <a href="/libaoge/#" target="_blank">
          <img src="@/assets/images/libaohouse.jpg">
        </a>
      </div>
      <!--      <div class="header-nav-logo">-->
      <!--        <img src="@/assets/images/logo.png">-->
      <!--      </div>-->
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name[$i18n.locale])"
        >
          <router-link :to="item.path" v-if="!item.target">
            {{ item.name[$i18n.locale] }}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <a :href="item.path" v-else target="_blank">
            {{ item.name[$i18n.locale] }}
            <i class="underline"></i>
          </a>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <div class="menu-box" @mousemove="showManNav = true" @mouseleave="showManNav = false">
        <img src="../assets/images/menu_white.png" alt="">
      </div>
    </div>
    <div class="hoverMenu-box container" v-show="showManNav" @mousemove="showManNav = true"
         @mouseleave="showManNav = false">
      <ul>
        <a href="/#/home" target="_blank">
          {{$t('header.hover.home')}}
        </a>
        <a href="/#/coffee/home" target="_blank">
          {{$t('header.hover.coffee')}}
        </a>
        <a href="/libaoge/#/home" target="_blank">
          {{$t('header.hover.restaurant')}}
        </a>
        <a href="/#/about" target="_blank">
          {{$t('header.hover.about')}}
        </a>
        <a href="http://jp-2.frp.one:35113/#/home" target="_blank">
          {{$t('header.hover.investor')}}
        </a>
        <a href="http://jp-2.frp.one:35113/#/contact" target="_blank">
          {{$t('header.hover.contact')}}
        </a>
        <a href="/#/join" target="_blank">
          {{ $t('header.hover.join')}}
        </a>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!--      <div class="header-nav-m-logo">-->
      <!--        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">-->
      <!--      </div>-->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span>{{ curMobileNavName }}</span>
          <span :class="menuClass"></span>
        </div>
        <div class="locale-box" @click.stop="showMobileLanguage = true">
          <img src="@/assets/images/language.png" alt="">
          <p>{{ curLanguageName }}</p>
          <span class="glyphicon glyphicon-menu-down"></span>
          <div class="language-list" :style="{'transform':showMobileLanguage?'scaleY(1)':'scaleY(0)'}">
            <div :class="{'language-active':lang === item.value}"
                 v-for="item in langList" :key="item.value" @click.stop="selectLang(item.value)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name[$i18n.locale])"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name[$i18n.locale] }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      showManNav: false,
      showMobileLanguage: false,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      langList: [
        {
          name: "繁",
          value: "tc"
        },
        {
          name: "简",
          value: "sc"
        },
        {
          name: "ENG",
          value: "en"
        },
      ],
      navList: [
        {
          name: {
            sc: "餐饮",
            tc: "餐飲",
            en: "Catering"
          },
          path: "/home",
          children: []
        },
        {
          name: {
            sc: "关于我们",
            tc: "關於我們",
            en: "About Us"
          },
          path: "/about",
          children: []
        },
        {
          name: {
            sc: "婚宴及推广",
            tc: "婚宴及推廣",
            en: "Wedding Banquets and Promotions"
          },
          path: "/wedding-information",
          children: []
        },
        // {
        //   name: {
        //     sc: "投资者关系",
        //     tc: "投資者關係",
        //     en: "Investor Relations"
        //   },
        //   path: "https://mediumir.com/zh-hant/01869",
        //   target: '_blank',//
        //   children: []
        // },
        {
          name: {
            sc: "联系我们",
            tc: "聯繫我們",
            en: "Contact Us"
          },
          path: "/contact",
          children: []
        }
      ],
      lang: 'en',
      top: 0,
      navShow: true
    };
  },
  computed: {
    curLanguageName() {
      return this.langList.find(item => item.value === this.lang).name;
    },
    curMobileNavName() {
      return this.navList[this.navIndex].name[this.lang];
    }
  },
  // 监听top值的变化
  watch: {
    top() {
      this.navShow = this.top <= 100;
    },
    $route: {
      handler() {
        this.navIndex = this.navList.findIndex(item => item.path === this.$route.path);
        if (this.$route.query.locale) {
          this.selectLang(this.$route.query.locale);
        }
      },
      immediate: true
    },
  },
  // 获取浏览器滚轮
  mounted() {
    window.addEventListener('scroll', () => {
      this.top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    });
    // this.lang = window.localStorage.getItem('locale') || 'sc';
    // this.selectLang(this.lang);
    // 关闭
    document.addEventListener('click', () => {
      this.showMobileLanguage = false
    })
    this.lang = this.$i18n.locale;
  },
  methods: {
    showLanguage() {

    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    selectLang(lang) {
      let langFlags = ['tc', 'sc', 'en'];
      if (!langFlags.includes(lang)) {
        return;
      }
      this.showMobileLanguage = false;
      this.lang = lang;
      this.$i18n.locale = lang;
      window.localStorage.setItem('locale', lang);
      this.$router.replace({
        path: this.$route.path,
        query: {
          locale: lang
        }
      });
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: rgba(116, 125, 140, 0.4);
  transition: all ease 0.6s;
  position: fixed;
  z-index: 9999;
  width: 100%;
  color: #000;
}

.menu-box {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 20px;
}

.hoverMenu-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, .1);
  padding: 20px 0;
  transform: translateY(-30px);
}

.hoverMenu-box a {
  color: #fff;
  margin: 0 10px;
  font-size: 18px;
  text-decoration: none;
  transition: all .3s;
  overflow: hidden;
}

.hoverMenu-box a:hover {
  color: #BC9B5D;
}

.locale-box {
  display: flex;
  position: absolute;
  align-items: center;
  right: 10px;
  top: 60%;
  transform: translateY(-50%);
}

.language-list {
  position: absolute;
  top: 115%;
  padding: 0 10px;
  right: 0;
  color: #000;
  background: #fff;
  transition: all .3s;
  transform-origin: 50% top;
  border-radius: 5px;
  font-size: 14px;
}

.language-active {
  color: #BCAF7B;
  font-weight: bold;
  font-size: 16px;
}

.language-list::before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  bottom: 99%;
  left: 50%;
  transform: translateX(-50%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
}

.locale-box img {
  width: 18px;
  height: 18px;
}

.locale-box p {
  margin: 0 6px;
  font-size: 16px;
}

.locale-box span {
  font-size: 14px;
}

.language {
  display: flex;
  align-items: center;
  color: #000;
}

.language li {
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all .3s;
}

.active-lang {
  font-weight: bold;
  font-size: 16px;
  color: #BCAF7B;
}

.language .shop img {
  width: 30px;
  height: 30px;
}

#header .header-top {
  height: 50px;
  //color: #474747;
  font-size: 12px;
  line-height: 50px;
  background: #f4f4f4;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 100px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 90px;
  height: 100%;
  float: left;
  position: relative;
  cursor: pointer;
}

/* 导航栏logo */

#header .header-nav .header-nav-logo:nth-child(2) {
  margin: 0 15px;
}


/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 90px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

#header .header-nav .libaohouse img {
  height: 80px;
}

#header .header-nav .header-nav-logo:nth-child(1) {
  width: 70px;
}

#header .header-nav .header-nav-logo:nth-child(1) img {
  height: 65px;
  width: 100%;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  //color: #000;
  color: #f4f4f4;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #BCAF7B;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #BCAF7B;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #BC9B5D;
  text-decoration: none;
  border-bottom: 2px solid #BC9B5D;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #BCAF7B;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: -20px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  #header .header-nav-m .header-nav-m-menu-wrapper span:nth-child(1) {
    font-size: 18px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #BCAF7B;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue